export default __webpack_public_path__ + "static/media/404.329293ae.png";